import { useContext } from 'react';

import { HistogramYAxisConfigContext } from '../contexts/HistogramYAxisConfig.context.js';

export const useYAxisConfig = () => useContext(HistogramYAxisConfigContext);
